import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import PartnerControlLayout from './layouts/PartnerControlLayout';
import PenaltyGenerationPage from './penaltyGeneration/PenaltyGenerationPage';
import AppealReviewPage from './appealReview/AppealReviewPage';
import PenaltyCenterPage from './penaltyCenter/PenaltyCenterPage';
import PenaltyDetailPage from './penaltyCenter/PenaltyDetailPage';
import PartnerControlDownloadPage from './download/PartnerControlDownloadPage';
import DriverActivityListPage from '../driver-ops/activity/DriverActivityListPage';
import DriverActivityFormPage from '../driver-ops/activity/DriverActivityFormPage';
import DriverActivityDetailPage from '../driver-ops/activity/DriverActivityDetailPage';

const PartnerControlRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><PartnerControlLayout /></AuthGuard>}>
                <Route path="penaltyReview/generation" element={<PenaltyGenerationPage />} />
                <Route path="penaltyReview/appeal-review" element={<AppealReviewPage />} />
                <Route path="penaltyCenter" element={<PenaltyCenterPage />} />
                <Route path="penaltyCenter/:id" element={<PenaltyDetailPage />} />
                <Route path="download" element={<PartnerControlDownloadPage />} />
                <Route path="driver-activity" element={<DriverActivityListPage />} />
                <Route path="driver-activity/new" element={<DriverActivityFormPage />} />
                <Route path="driver-activity/:id/edit" element={<DriverActivityFormPage />} />
                <Route path="driver-activity/:id" element={<DriverActivityDetailPage />} />
            </Route>
        </Routes>
    );
};

export default PartnerControlRoutes;
